export default "__VITE_ASSET__DwO4jVLW__"